import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface MessagingViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class MessagingViewPage extends Component<MessagingViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.messaging(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}